import { NgModule, Component } from '@angular/core';
import {StoreModule} from '@ngrx/store';
import {StoreLogMonitorModule, useLogMonitor} from '@ngrx/store-log-monitor';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {StoreUndoModule} from 'ngrx-undo';
import { RouterStoreModule } from '@ngrx/router-store';

import { AppModule } from '../app/application/app.module';
import {rootReducer} from '../app/stateManagement/rootReducer';
import { VersionCheckerService } from '../app/shared/services/version-checker.service';

@Component({
    selector: 'tr-application-wrapper',
    template: `
        <tr-application></tr-application>
        <!-- ngrx-store-log-monitor toggleCommand="ctrl-t" positionCommand="ctrl-m"></ngrx-store-log-monitor -->
    `
})
export class ApplicationWrapperContainerComponent {
    constructor(private versionCheckerService: VersionCheckerService) {
        //versionCheckerService.start();
    }
}

@NgModule({
    imports: [
        RouterStoreModule.connectRouter(),
        StoreModule.provideStore(rootReducer), StoreDevtoolsModule.instrumentStore({
            monitor: useLogMonitor({
                visible: false,
                position: 'right'
            })
        }), StoreUndoModule.interceptStore({bufferSize: 100}), StoreLogMonitorModule, AppModule],
    declarations: [ApplicationWrapperContainerComponent],
    bootstrap: [ApplicationWrapperContainerComponent]
})
export class DevModule {
}



// WEBPACK FOOTER //
// ./src/setup/dev.module.ts